export default "__VITE_ASSET__b7e831f0__"